import { useSendFeedbackMutation } from '../../../__generated__/chirp/com/hubspot/learning/center/search/rpc/SearchChirpService.hooks';
export const useSearchFeedback = () => useSendFeedbackMutation();